import React, { useState } from 'react';

const PaywallModal = ({ onClose }) => {
  const [loading, setLoading] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handleSubscribe = async (plan) => {
    setLoading(true);
    setSelectedPlan(plan);
    
    try {
      const storedUser = localStorage.getItem('user');
      const user = storedUser ? JSON.parse(storedUser) : null;
      
      if (!user) {
        alert('Please log in to subscribe');
        setLoading(false);
        return;
      }

      const apiUrl = process.env.REACT_APP_API_URL || 'https://freehappyone.com';
      const response = await fetch(`${apiUrl}/api/v1/checkout/create-checkout-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          plan: plan,
          user_email: user.email,
          user_id: user.id
        })
      });

      const data = await response.json();
      
      if (data.checkout_url) {
        window.location.href = data.checkout_url;
      } else {
        alert('Unable to start checkout. Please try again.');
      }
    } catch (error) {
      console.error('Checkout error:', error);
      alert('An error occurred. Please try again.');
    } finally {
      setLoading(false);
      setSelectedPlan(null);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '20px',
      animation: 'fadeIn 0.3s'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '40px',
        maxWidth: '900px',
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
        position: 'relative'
      }}>
        {/* Close Button */}
        <button 
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '28px',
            cursor: 'pointer',
            color: '#666',
            padding: '4px 8px'
          }}
        >
          ×
        </button>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🎉</div>
          <h2 style={{
            fontSize: '32px',
            fontWeight: 'bold',
            marginBottom: '12px',
            color: '#1a1a2e'
          }}>
            You've Experienced the FHO Platform!
          </h2>
          <p style={{
            fontSize: '18px',
            color: '#666',
            lineHeight: '1.6'
          }}>
            You've used all <strong>7 free responses</strong>. Continue your transformation journey with unlimited access.
          </p>
        </div>

        {/* Pricing Cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '24px',
          marginBottom: '40px'
        }}>
          {/* Monthly Plan */}
          <div style={{
            border: '3px solid #ddd',
            borderRadius: '12px',
            padding: '32px',
            transition: 'all 0.3s',
            cursor: 'pointer'
          }}>
            <h3 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '12px', color: '#1a1a2e' }}>
              Monthly
            </h3>
            <div style={{ marginBottom: '24px' }}>
              <span style={{ fontSize: '48px', fontWeight: 'bold', color: '#667eea' }}>$39</span>
              <span style={{ fontSize: '18px', color: '#666' }}>/month</span>
            </div>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              marginBottom: '24px',
              fontSize: '15px',
              lineHeight: '2',
              color: '#444'
            }}>
              <li>✅ <strong>Unlimited conversations</strong> with all 4 coaches</li>
              <li>✅ Emit, SAFE, Family Coach & Mental Performance</li>
              <li>✅ Full progress tracking & analytics</li>
              <li>✅ Cancel anytime</li>
            </ul>
            <button 
              onClick={() => handleSubscribe('monthly')}
              disabled={loading}
              style={{
                width: '100%',
                backgroundColor: loading && selectedPlan === 'monthly' ? '#999' : '#667eea',
                color: 'white',
                padding: '16px',
                borderRadius: '8px',
                fontSize: '18px',
                fontWeight: 'bold',
                border: 'none',
                cursor: loading ? 'wait' : 'pointer',
                opacity: loading && selectedPlan !== 'monthly' ? 0.7 : 1
              }}
            >
              {loading && selectedPlan === 'monthly' ? 'Loading...' : 'Subscribe Monthly'}
            </button>
          </div>

          {/* Yearly Plan - RECOMMENDED */}
          <div style={{
            border: '3px solid #667eea',
            borderRadius: '12px',
            padding: '32px',
            position: 'relative',
            backgroundColor: '#F0F8FF',
            cursor: 'pointer'
          }}>
            <div style={{
              position: 'absolute',
              top: '-12px',
              right: '20px',
              backgroundColor: '#FF6B6B',
              color: 'white',
              padding: '6px 16px',
              borderRadius: '20px',
              fontSize: '13px',
              fontWeight: 'bold'
            }}>
              SAVE $108
            </div>
            <h3 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '12px', color: '#1a1a2e' }}>
              Yearly
            </h3>
            <div style={{ marginBottom: '8px' }}>
              <span style={{ fontSize: '48px', fontWeight: 'bold', color: '#667eea' }}>$360</span>
              <span style={{ fontSize: '18px', color: '#666' }}>/year</span>
            </div>
            <div style={{
              fontSize: '14px',
              color: '#27ae60',
              fontWeight: 'bold',
              marginBottom: '16px'
            }}>
              🎁 Just $30/month - Save 23%!
            </div>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              marginBottom: '24px',
              fontSize: '15px',
              lineHeight: '2',
              color: '#444'
            }}>
              <li>✅ <strong>Unlimited conversations</strong> with all 4 coaches</li>
              <li>✅ Emit, SAFE, Family Coach & Mental Performance</li>
              <li>✅ Full progress tracking & analytics</li>
              <li>✅ Priority support</li>
            </ul>
            <button 
              onClick={() => handleSubscribe('yearly')}
              disabled={loading}
              style={{
                width: '100%',
                backgroundColor: loading && selectedPlan === 'yearly' ? '#999' : '#667eea',
                color: 'white',
                padding: '16px',
                borderRadius: '8px',
                fontSize: '18px',
                fontWeight: 'bold',
                border: 'none',
                cursor: loading ? 'wait' : 'pointer',
                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
                opacity: loading && selectedPlan !== 'yearly' ? 0.7 : 1
              }}
            >
              {loading && selectedPlan === 'yearly' ? 'Loading...' : 'Subscribe Yearly (Best Value!)'}
            </button>
          </div>
        </div>

        {/* Trust Signals */}
        <div style={{
          textAlign: 'center',
          fontSize: '14px',
          color: '#888',
          paddingTop: '20px',
          borderTop: '1px solid #eee'
        }}>
          <p style={{ marginBottom: '8px' }}>
            🔒 <strong>Secure payment</strong> powered by Stripe
          </p>
          <p>
            Cancel anytime • 7-day money-back guarantee
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaywallModal;
